import { useContext, createContext } from 'react';
import { InfoBannerContextProps } from '../types';

export const InfoBannerContext = createContext<InfoBannerContextProps | null>(null);

export const useInfoBannerContext = () => {
  const context = useContext(InfoBannerContext);

  if (!context) throw new Error('useInfoBannerContext must be use inside InfoBannerProvider');

  return context;
};
